import script from "./LeaderProjectCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectCompetencies.vue?vue&type=style&index=0&id=6ee21a79&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee21a79"]])

export default __exports__